import {type IAsset} from '@netx/core-asset-next/schema';
import {AssetViewName} from '@netx/core-asset-views';

export const assetHasPdf = (
	asset?: Pick<IAsset, 'assetId' | 'filetypelabel' | 'viewNames'>,
) => {
	if (!asset || !asset.viewNames) return false;
	return (
		// The server does not (IMO) accurately reflect a document
		// despite this being an array, an xlsx will have a single value of 'spreadsheet'
		// We will make the assumption that if the views contain a pdf then we have a pdf
		// asset.fileFormatFamily.includes('document') &&
		asset.viewNames.includes(AssetViewName.PDF) || asset.filetypelabel === 'pdf'
	);
};

export default assetHasPdf;
